// extracted by mini-css-extract-plugin
module.exports = {"blockTitle":"SideProperties_blockTitle__1idk5","icon":"SideProperties_icon__AKMTq","blockContentWithTooltip":"SideProperties_blockContentWithTooltip__12wqO"};